import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { DepositWithdrawPage } from './deposit-withdraw.page';

@NgModule({
  declarations: [
    DepositWithdrawPage,
  ],
  imports: [
    CommonModule,
    CoreModule,
    ReactiveFormsModule,
  ],
  exports: [
    DepositWithdrawPage,
  ]
})
export class DepositWithdrawModule { }
